import { notification } from 'antd';
import React, { FC, useEffect } from 'react';
import { PICKER_DATE_MASK, PICKER_TIME_MASK } from 'shared/constants';
import {
  checkDisabledDatesWithMinuteStep,
  disabledStartTimePoll,
  disabledTime,
  setDateFromString,
} from 'shared/helpers/date';
import dayjs, { Dayjs } from 'dayjs';
import DatePickerWithDots from 'shared/components/datePickerWithDots/DatePickerWithDots';
import TimePickerWithDots from 'shared/components/timePickerWithDots/TimePickerWithDots';
import { MINUTE_STEP } from 'shared/constants/date';
import style from './index.module.scss';

type TPollDatesProps = {
  onStartTimeChange: (time: string | string[]) => void;
  onStartDateChange: (date: string | string[]) => void;
  onEndTimeChange: (time?: string | string[]) => void;
  onEndDateChange: (date: string | string[]) => void;
  startTime?: string;
  endTime?: string;
  startDate?: string;
  endDate?: string;
};

const PollDates: FC<TPollDatesProps> = ({
  onEndDateChange,
  onEndTimeChange,
  onStartDateChange,
  onStartTimeChange,
  endDate,
  endTime,
  startDate,
  startTime,
}) => {
  useEffect(() => {
    if (!startTime || !endTime) {
      return;
    }
    const timesDiff = dayjs(startTime, PICKER_TIME_MASK).diff(dayjs(endTime, PICKER_TIME_MASK));
    const isEndTimeBiggerThanStartTime = timesDiff > 0 ? false : true;

    if ((startTime === endTime || !isEndTimeBiggerThanStartTime) && startDate && startDate === endDate) {
      onEndTimeChange(undefined);
      notification.warning({ message: 'Дата начала должна быть раньше даты окончания' });
      return;
    }
  }, [startDate, endDate, startTime, endTime]);

  const onDateStartChange = (date: Dayjs | null, dateString: string | string[]) => {
    if (date) {
      onStartDateChange(date.format(PICKER_DATE_MASK));
    }
  };
  const onTimeStartChange = (time: Dayjs | null, dateString: string | string[]) => {
    onStartTimeChange(dateString);
  };

  const onDateEndChange = (date: Dayjs | null, dateString: string | string[]) => {
    if (date) {
      onEndDateChange(date.format(PICKER_DATE_MASK));
    }
  };
  const onTimeEndChange = (time: Dayjs | null, dateString: string | string[]) => {
    onEndTimeChange(dateString);
  };

  return (
    <div className={style['poll-dates']}>
      <div className={style.start}>
        <p>Дата начала опроса:</p>
        <div className={style['date-field']}>
          <DatePickerWithDots
            format={PICKER_DATE_MASK}
            onChange={onDateStartChange}
            value={startDate ? dayjs(startDate, PICKER_DATE_MASK) : undefined}
            disabledDate={current => checkDisabledDatesWithMinuteStep(current, true)}
          />
          <TimePickerWithDots
            format={PICKER_TIME_MASK}
            minuteStep={MINUTE_STEP}
            onChange={onTimeStartChange}
            value={setDateFromString(startTime, PICKER_TIME_MASK)}
            disabledTime={() => disabledStartTimePoll(startDate)}
            showNow={false}
            needConfirm={false}
            changeOnScroll={false}
          />
        </div>
      </div>
      <div className={style.end}>
        <p>Дата окончания опроса:</p>
        <div className={style['date-field']}>
          <DatePickerWithDots
            format={PICKER_DATE_MASK}
            disabledDate={current => checkDisabledDatesWithMinuteStep(current, true)}
            onChange={onDateEndChange}
            value={endDate ? dayjs(endDate, PICKER_DATE_MASK) : undefined}
          />
          <TimePickerWithDots
            format={PICKER_TIME_MASK}
            minuteStep={MINUTE_STEP}
            onChange={onTimeEndChange}
            value={setDateFromString(endTime, PICKER_TIME_MASK)}
            disabledTime={() => disabledTime(startDate, endDate, startTime)}
            showNow={false}
            needConfirm={false}
            changeOnScroll={false}
          />
        </div>
      </div>
    </div>
  );
};

export default PollDates;
